/* tslint:disable */
/* eslint-disable */
/**
 * Credify API doc version 1
 * API documentations version 1.
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: dev@credify.one
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AttachClaimTokens } from '../model';
// @ts-ignore
import { AttachedClaimsResponse } from '../model';
// @ts-ignore
import { ClaimProvidersResponse } from '../model';
// @ts-ignore
import { CommonResponse } from '../model';
// @ts-ignore
import { ScopesDefinitionData } from '../model';
// @ts-ignore
import { ScopesDefinitionResponse } from '../model';
// @ts-ignore
import { UpdateBlacklistDto } from '../model';
// @ts-ignore
import { WhitelistServicesResponse } from '../model';
/**
 * ClaimProviderApi - axios parameter creator
 * @export
 */
export const ClaimProviderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * This returns attached custom claims to a specified user. This is to be requested by individual entities. If `provider_id` is set in its query params, the response will be filtered by the specified provider.
         * @summary Gets attached custom claim values
         * @param {string} [providerId] Provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedClaim: async (providerId?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/claim-providers/attached-claims`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (providerId !== undefined) {
                localVarQueryParameter['provider_id'] = providerId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This operation fetches claim provider list that are providing custom claims. `It does not contain the API requesting organization itself`.
         * @summary Gets claim providers list
         * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
         * @param {number} [page] Page number. default is 1
         * @param {number} [limit] Page size. default is 50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimProviderList: async (category?: string, page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/claim-providers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (category !== undefined) {
                localVarQueryParameter['category'] = category;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
         * @summary Gets scopes definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopeDefinition: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/claim-providers/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This returns whitelisted services to access the API calling service. The whitelisted services can access the data of the claim provider, whose category falls into the same one.
         * @summary Get whitelisted services
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistedServiceList: async (page?: number, limit?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/v1/claim-providers/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates a reference of user\'s claim values in certain scopes. Currently this is supposed to be called by claim providers, therefore it needs API_KEY (tentative). The custom claim values will be stored by claim providers, not Credify, so this API will receive only hashed claim values with a corresponding signature with the claim provider\'s signing key. In order to have a decent entropy, each scope will use commitments generated on the claim provider\'s system.
         * @summary Update claim values
         * @param {string} id Individual Entity ID
         * @param {AttachClaimTokens} attachClaimTokens 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttachedClaim: async (id: string, attachClaimTokens: AttachClaimTokens, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateAttachedClaim', 'id', id)
            // verify required parameter 'attachClaimTokens' is not null or undefined
            assertParamExists('updateAttachedClaim', 'attachClaimTokens', attachClaimTokens)
            const localVarPath = `/v1/claim-providers/entities/{id}/claims`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = attachClaimTokens

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates new claim provider\'s scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
         * @summary Updates a claim provider\'s scopes definition
         * @param {ScopesDefinitionData} scopesDefinitionData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScopeDefinition: async (scopesDefinitionData: ScopesDefinitionData, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'scopesDefinitionData' is not null or undefined
            assertParamExists('updateScopeDefinition', 'scopesDefinitionData', scopesDefinitionData)
            const localVarPath = `/v1/claim-providers/scopes`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = scopesDefinitionData

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This updates whitelisted services to access the API calling service.
         * @summary Update whitelisted services
         * @param {UpdateBlacklistDto} updateBlacklistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelistedService: async (updateBlacklistDto: UpdateBlacklistDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateBlacklistDto' is not null or undefined
            assertParamExists('updateWhitelistedService', 'updateBlacklistDto', updateBlacklistDto)
            const localVarPath = `/v1/claim-providers/whitelist`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = updateBlacklistDto

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ClaimProviderApi - functional programming interface
 * @export
 */
export const ClaimProviderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ClaimProviderApiAxiosParamCreator(configuration)
    return {
        /**
         * This returns attached custom claims to a specified user. This is to be requested by individual entities. If `provider_id` is set in its query params, the response will be filtered by the specified provider.
         * @summary Gets attached custom claim values
         * @param {string} [providerId] Provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAttachedClaim(providerId?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AttachedClaimsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAttachedClaim(providerId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This operation fetches claim provider list that are providing custom claims. `It does not contain the API requesting organization itself`.
         * @summary Gets claim providers list
         * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
         * @param {number} [page] Page number. default is 1
         * @param {number} [limit] Page size. default is 50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClaimProviderList(category?: string, page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClaimProvidersResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClaimProviderList(category, page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
         * @summary Gets scopes definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getScopeDefinition(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ScopesDefinitionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getScopeDefinition(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This returns whitelisted services to access the API calling service. The whitelisted services can access the data of the claim provider, whose category falls into the same one.
         * @summary Get whitelisted services
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWhitelistedServiceList(page?: number, limit?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WhitelistServicesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWhitelistedServiceList(page, limit, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates a reference of user\'s claim values in certain scopes. Currently this is supposed to be called by claim providers, therefore it needs API_KEY (tentative). The custom claim values will be stored by claim providers, not Credify, so this API will receive only hashed claim values with a corresponding signature with the claim provider\'s signing key. In order to have a decent entropy, each scope will use commitments generated on the claim provider\'s system.
         * @summary Update claim values
         * @param {string} id Individual Entity ID
         * @param {AttachClaimTokens} attachClaimTokens 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateAttachedClaim(id: string, attachClaimTokens: AttachClaimTokens, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateAttachedClaim(id, attachClaimTokens, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates new claim provider\'s scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
         * @summary Updates a claim provider\'s scopes definition
         * @param {ScopesDefinitionData} scopesDefinitionData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateScopeDefinition(scopesDefinitionData: ScopesDefinitionData, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateScopeDefinition(scopesDefinitionData, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This updates whitelisted services to access the API calling service.
         * @summary Update whitelisted services
         * @param {UpdateBlacklistDto} updateBlacklistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWhitelistedService(updateBlacklistDto: UpdateBlacklistDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommonResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWhitelistedService(updateBlacklistDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ClaimProviderApi - factory interface
 * @export
 */
export const ClaimProviderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ClaimProviderApiFp(configuration)
    return {
        /**
         * This returns attached custom claims to a specified user. This is to be requested by individual entities. If `provider_id` is set in its query params, the response will be filtered by the specified provider.
         * @summary Gets attached custom claim values
         * @param {string} [providerId] Provider ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAttachedClaim(providerId?: string, options?: any): AxiosPromise<AttachedClaimsResponse> {
            return localVarFp.getAttachedClaim(providerId, options).then((request) => request(axios, basePath));
        },
        /**
         * This operation fetches claim provider list that are providing custom claims. `It does not contain the API requesting organization itself`.
         * @summary Gets claim providers list
         * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
         * @param {number} [page] Page number. default is 1
         * @param {number} [limit] Page size. default is 50
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClaimProviderList(category?: string, page?: number, limit?: number, options?: any): AxiosPromise<ClaimProvidersResponse> {
            return localVarFp.getClaimProviderList(category, page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This returns scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
         * @summary Gets scopes definition
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getScopeDefinition(options?: any): AxiosPromise<ScopesDefinitionResponse> {
            return localVarFp.getScopeDefinition(options).then((request) => request(axios, basePath));
        },
        /**
         * This returns whitelisted services to access the API calling service. The whitelisted services can access the data of the claim provider, whose category falls into the same one.
         * @summary Get whitelisted services
         * @param {number} [page] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWhitelistedServiceList(page?: number, limit?: number, options?: any): AxiosPromise<WhitelistServicesResponse> {
            return localVarFp.getWhitelistedServiceList(page, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates a reference of user\'s claim values in certain scopes. Currently this is supposed to be called by claim providers, therefore it needs API_KEY (tentative). The custom claim values will be stored by claim providers, not Credify, so this API will receive only hashed claim values with a corresponding signature with the claim provider\'s signing key. In order to have a decent entropy, each scope will use commitments generated on the claim provider\'s system.
         * @summary Update claim values
         * @param {string} id Individual Entity ID
         * @param {AttachClaimTokens} attachClaimTokens 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateAttachedClaim(id: string, attachClaimTokens: AttachClaimTokens, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updateAttachedClaim(id, attachClaimTokens, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates new claim provider\'s scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
         * @summary Updates a claim provider\'s scopes definition
         * @param {ScopesDefinitionData} scopesDefinitionData 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScopeDefinition(scopesDefinitionData: ScopesDefinitionData, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updateScopeDefinition(scopesDefinitionData, options).then((request) => request(axios, basePath));
        },
        /**
         * This updates whitelisted services to access the API calling service.
         * @summary Update whitelisted services
         * @param {UpdateBlacklistDto} updateBlacklistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWhitelistedService(updateBlacklistDto: UpdateBlacklistDto, options?: any): AxiosPromise<CommonResponse> {
            return localVarFp.updateWhitelistedService(updateBlacklistDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ClaimProviderApi - interface
 * @export
 * @interface ClaimProviderApi
 */
export interface ClaimProviderApiInterface {
    /**
     * This returns attached custom claims to a specified user. This is to be requested by individual entities. If `provider_id` is set in its query params, the response will be filtered by the specified provider.
     * @summary Gets attached custom claim values
     * @param {string} [providerId] Provider ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    getAttachedClaim(providerId?: string, options?: AxiosRequestConfig): AxiosPromise<AttachedClaimsResponse>;

    /**
     * This operation fetches claim provider list that are providing custom claims. `It does not contain the API requesting organization itself`.
     * @summary Gets claim providers list
     * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
     * @param {number} [page] Page number. default is 1
     * @param {number} [limit] Page size. default is 50
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    getClaimProviderList(category?: string, page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<ClaimProvidersResponse>;

    /**
     * This returns scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
     * @summary Gets scopes definition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    getScopeDefinition(options?: AxiosRequestConfig): AxiosPromise<ScopesDefinitionResponse>;

    /**
     * This returns whitelisted services to access the API calling service. The whitelisted services can access the data of the claim provider, whose category falls into the same one.
     * @summary Get whitelisted services
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    getWhitelistedServiceList(page?: number, limit?: number, options?: AxiosRequestConfig): AxiosPromise<WhitelistServicesResponse>;

    /**
     * This updates a reference of user\'s claim values in certain scopes. Currently this is supposed to be called by claim providers, therefore it needs API_KEY (tentative). The custom claim values will be stored by claim providers, not Credify, so this API will receive only hashed claim values with a corresponding signature with the claim provider\'s signing key. In order to have a decent entropy, each scope will use commitments generated on the claim provider\'s system.
     * @summary Update claim values
     * @param {string} id Individual Entity ID
     * @param {AttachClaimTokens} attachClaimTokens 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    updateAttachedClaim(id: string, attachClaimTokens: AttachClaimTokens, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This updates new claim provider\'s scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
     * @summary Updates a claim provider\'s scopes definition
     * @param {ScopesDefinitionData} scopesDefinitionData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    updateScopeDefinition(scopesDefinitionData: ScopesDefinitionData, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

    /**
     * This updates whitelisted services to access the API calling service.
     * @summary Update whitelisted services
     * @param {UpdateBlacklistDto} updateBlacklistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApiInterface
     */
    updateWhitelistedService(updateBlacklistDto: UpdateBlacklistDto, options?: AxiosRequestConfig): AxiosPromise<CommonResponse>;

}

/**
 * ClaimProviderApi - object-oriented interface
 * @export
 * @class ClaimProviderApi
 * @extends {BaseAPI}
 */
export class ClaimProviderApi extends BaseAPI implements ClaimProviderApiInterface {
    /**
     * This returns attached custom claims to a specified user. This is to be requested by individual entities. If `provider_id` is set in its query params, the response will be filtered by the specified provider.
     * @summary Gets attached custom claim values
     * @param {string} [providerId] Provider ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public getAttachedClaim(providerId?: string, options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).getAttachedClaim(providerId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This operation fetches claim provider list that are providing custom claims. `It does not contain the API requesting organization itself`.
     * @summary Gets claim providers list
     * @param {string} [category] Claim Provider\&#39;s organization category. If it is not specified, all categories are returned.
     * @param {number} [page] Page number. default is 1
     * @param {number} [limit] Page size. default is 50
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public getClaimProviderList(category?: string, page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).getClaimProviderList(category, page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
     * @summary Gets scopes definition
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public getScopeDefinition(options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).getScopeDefinition(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This returns whitelisted services to access the API calling service. The whitelisted services can access the data of the claim provider, whose category falls into the same one.
     * @summary Get whitelisted services
     * @param {number} [page] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public getWhitelistedServiceList(page?: number, limit?: number, options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).getWhitelistedServiceList(page, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates a reference of user\'s claim values in certain scopes. Currently this is supposed to be called by claim providers, therefore it needs API_KEY (tentative). The custom claim values will be stored by claim providers, not Credify, so this API will receive only hashed claim values with a corresponding signature with the claim provider\'s signing key. In order to have a decent entropy, each scope will use commitments generated on the claim provider\'s system.
     * @summary Update claim values
     * @param {string} id Individual Entity ID
     * @param {AttachClaimTokens} attachClaimTokens 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public updateAttachedClaim(id: string, attachClaimTokens: AttachClaimTokens, options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).updateAttachedClaim(id, attachClaimTokens, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates new claim provider\'s scopes definition. This is to be requested by organization entities that are activated to be a claim provider.
     * @summary Updates a claim provider\'s scopes definition
     * @param {ScopesDefinitionData} scopesDefinitionData 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public updateScopeDefinition(scopesDefinitionData: ScopesDefinitionData, options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).updateScopeDefinition(scopesDefinitionData, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This updates whitelisted services to access the API calling service.
     * @summary Update whitelisted services
     * @param {UpdateBlacklistDto} updateBlacklistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ClaimProviderApi
     */
    public updateWhitelistedService(updateBlacklistDto: UpdateBlacklistDto, options?: AxiosRequestConfig) {
        return ClaimProviderApiFp(this.configuration).updateWhitelistedService(updateBlacklistDto, options).then((request) => request(this.axios, this.basePath));
    }
}
